<template>
  <div>{{ fn_goToCient() }}</div>
</template>
<script>
import config from "../../../config.json";
export default {
  methods: {
    fn_goToCient() {
      const lang = localStorage.getItem("lang") || "vi";
      const clientUrl = lang == "vi" ? config.urlClient : config.urlClientEn;
      window.location.href = `${clientUrl}${lang}/danh-gia-muc-do-chuyen-doi-so`;
    },
    setToken(domain, qparams) {
      return `${domain}?${this.queryBuilder(qparams)}`;
    },
    queryBuilder(parameters) {
      if (typeof parameters === "string") return parameters;
      var query = [];
      for (var key in parameters) {
        if (parameters.hasOwnProperty(key)) {
          query.push(key + "=" + encodeURIComponent(parameters[key]));
        }
      }
      return query.join("&");
    },
  },
  created() {},
};
</script>
